import { message } from "antd";
import { addOnsService } from "../services/addOns";
import { localErrorHandler } from "../utils/errorHandler";
const namespace = "addOns";
const initialState = {
  list: [],
  pagination: { total: 0 },
  filters: {},
  currentAddOn: null,
  loading: {
    fetch: false,
    add: false,
    update: false,
    delete: false,
    fetchById: false,
  },
};
export const fetchAddOns = (params) => ({
  type: `${namespace}/fetchAddOns`,
  payload: params,
});
export const addAddOn = (data) => ({
  type: `${namespace}/addAddOn`,
  payload: data,
});
export const updateAddOn = (data) => ({
  type: `${namespace}/updateAddOn`,
  payload: data,
});
export const deleteAddOn = (id) => ({
  type: `${namespace}/deleteAddOn`,
  payload: id,
});
export const resetAddOns = () => ({
  type: `${namespace}/resetAddOns`,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *fetchAddOns({ payload }, { call, put, select }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      const currentFilters = yield select((state) => state[namespace].filters);
      const filtersToUse = payload || currentFilters;
      try {
        const response = yield call(addOnsService.getAddOns, filtersToUse);
        yield put({
          type: "setAddOns",
          payload: {
            list: response.data.list || [],
            pagination: { total: response.data.total || 0 },
            filters: filtersToUse,
          },
        });
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "fetch" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "fetch" });
      }
    },

    *addAddOn({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "add" });
      try {
        const response = yield call(addOnsService.addAddOn, payload);
        yield put({ type: "addAddOnToList", payload: response.data });
        message.success("Add-on added successfully");
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "add" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "add" });
      }
    },

    *updateAddOn({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "update" });
      try {
        const response = yield call(
          addOnsService.updateAddOn,
          payload.id,
          payload.data
        );
        yield put({ type: "updateAddOnInList", payload: response.data });
        message.success("Add-on updated successfully");
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "update" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "update" });
      }
    },

    *deleteAddOn({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "delete" });
      try {
        yield call(addOnsService.deleteAddOn, payload);
        yield put({ type: "removeAddOnFromList", payload });
        message.success("Add-on deleted successfully");
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "delete" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "delete" });
      }
    },

    *resetAddOns(_, { put }) {
      debugger;
      yield put({ type: "resetState" });
    },
  },
  reducers: {
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
    setAddOns(state, { payload }) {
      return { ...state, ...payload };
    },
    addAddOnToList(state, { payload }) {
      return { ...state, list: [payload, ...state.list] };
    },
    updateAddOnInList(state, { payload }) {
      const updatedList = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
      return { ...state, list: updatedList };
    },
    removeAddOnFromList(state, { payload }) {
      const updatedList = state.list.filter((item) => item.id !== payload);
      return { ...state, list: updatedList };
    },
    resetState() {
      return initialState;
    },
  },
};
